export * from './lib/data-sharing.module';
export * from './lib/config/data-sharing-config';
export * from './lib/services/profiles.service';
export * from './lib/mocks/mock-profiles-service';
export * from './lib/models/get-user-relations-response-model';
export * from './lib/components/data-sharing/data-sharing.component';
